export const experienceData = [
    {
        id: 1,
        company: 'Ministère de la Santé Publique',
        jobtitle: "Médecin d'Urgences",
    },
    {
        id: 2,
        company: 'Ministère de la Santé Publique',
        jobtitle: 'Médecin Principal de la Santé Publique',
    },
    {
        id: 3,
        company: 'Ministère de la Santé Publique',
        jobtitle: 'Médecin Major en Santé Publique',
    },
    {
        id: 4,
        company: 'Ministère de la Santé Publique',
        jobtitle: 'Chef de Circonscription',
    },
    {
        id: 5,
        company: 'Ministère de la Santé Publique',
        jobtitle: 'Médecine de Famille',
    },
]